import type { ReactNode } from "react"
import { createElement } from "react"
import NestedLinkAtm from "@onestore/hel/dist/components/atoms/NestedLinkAtm"
import ListItem from "@gatsby-plugin-generic-page/markdown/components/ListItem"
import { Text } from "@ionos-web-design-system/react"
import type { Components } from "react-markdown"

const modalTextOverrides: Components = {
  strong: ({ children }: { children: ReactNode }) => (
    <Text variant="body">{children}</Text>
  ),
  h1: ({ children }: { children: ReactNode }) => (
    <Text asChild variant="heading3xl" className="mb-3">
      <h1>{children}</h1>
    </Text>
  ),
  h2: ({ children }: { children: ReactNode }) => (
    <Text asChild variant="heading3xl" className="mb-3">
      <h2>{children}</h2>
    </Text>
  ),
  h3: ({ children }: { children: ReactNode }) => (
    <Text asChild variant="heading3xl" className="mb-3">
      <h3>{children}</h3>
    </Text>
  ),
  p: ({ children }: { children: ReactNode }) => (
    <Text asChild variant="body" className="mb-2">
      <p>{children}</p>
    </Text>
  ),
  a: (({ href, children }: { href?: string; children: ReactNode }) =>
    createElement(NestedLinkAtm, {
      href,
      openInNewTab: true,
      title: href ?? "",
      children,
    })) as Components["a"],
  li: ({ children }: { children: ReactNode }) => (
    <ListItem>{children}</ListItem>
  ),
} as Components

export default modalTextOverrides
